import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import I18NextHttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

import { ELanguage } from 'ts/enums/language';
import type { ArrayElement } from 'ts/types/utility-types';

export const DEFAULT_LANGUAGE = ELanguage.ENGLISH;

export const additionalLanguages = [
  ELanguage.ENGLISH,
  ELanguage.HINDI,
  ELanguage.PORTUGUESE,
  ELanguage.SPANISH,
  ELanguage.THAI,
  ELanguage.ARABIC,
  ELanguage.FRENCH
] as const;

export const languages = [DEFAULT_LANGUAGE, ...additionalLanguages] as const;

export type SupportedLanguage = ArrayElement<typeof languages>;

export const languageLabels: Record<SupportedLanguage, string> = {
  [ELanguage.ENGLISH]: 'English',
  [ELanguage.HINDI]: 'Hindi',
  [ELanguage.PORTUGUESE]: 'Português',
  [ELanguage.SPANISH]: 'Español',
  [ELanguage.THAI]: 'Thai',
  [ELanguage.ARABIC]: 'Arabic',
  [ELanguage.FRENCH]: 'Français'
};

export const localeConfigsDayJs: Record<SupportedLanguage, () => Promise<unknown>> = {
  en: () => import('dayjs/locale/en'),
  hi: () => import('dayjs/locale/hi'),
  pt: () => import('dayjs/locale/pt'),
  es: () => import('dayjs/locale/es'),
  th: () => import('dayjs/locale/th'),
  ar: () => import('dayjs/locale/ar'),
  fr: () => import('dayjs/locale/fr')
};

i18n
  .use(detector)
  .use(ChainedBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    supportedLngs: languages,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['path', 'navigator'], // ["path", "navigator", "querystring", 'cookie'],
      lookupFromPathIndex: 0,
      lookupQuerystring: 'lng'
      // caches: ["cookie"],
    },
    backend: {
      backends: [
        I18NextHttpBackend,
        resourcesToBackend((lng: string, ns: string) => import(`./locales/${lng}/${ns}.json`))
      ]
    }
  });

export const loadLocalesDayJs = () => {
  Promise.all(languages.map((language) => localeConfigsDayJs[language]().then()));
};

export default i18n;
